import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useAtomValue } from 'jotai';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { FullSizeCenteredColumn } from '../FlexBox';
import Dialog from '../Dialog';
import { renderRoutesTree, ROUTES_TREE } from '../../Router/routes';
import { CHANNEL_TYPES } from '../../Utils/constants/general';
import { selectedBranchAtom } from '../../Atoms';

const DefaultPageDialog = function DefaultPageDialog({
  open,
  defaultValue,
  onClose,
  onSubmit,
  userRoles,
}) {
  const intl = useIntl();
  const selectedBranch = useAtomValue(selectedBranchAtom);
  const [value, setValue] = useState(defaultValue);

  const routesOptions = renderRoutesTree(
    ROUTES_TREE,
    selectedBranch?.channelType === CHANNEL_TYPES.Long,
    userRoles,
    true
  );

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleClose = () => {
    onClose('');
    setValue('');
  };

  const handleSubmit = () => {
    onSubmit(value);
  };

  useEffect(() => {
    if (
      defaultValue &&
      routesOptions?.find((option) => option === defaultValue)
    )
      setValue(defaultValue);
    else setValue('CUSTOMERS');
  }, [defaultValue]);

  return (
    <Dialog
      id="default-page-dialog"
      title="SELECT_DEFAULT_PAGE"
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      width="sm"
      fullWidth
      minHeight="100px"
      disableBackdropClick
      disableEscapeKeyDown
      disableScroll
      dividers
    >
      <FullSizeCenteredColumn padding="16px">
        <FormControl fullWidth>
          <InputLabel id="default-page-select-inputlabel">
            {intl.messages.DEFAULT_PAGE}
          </InputLabel>
          <Select
            id="default-page-select"
            label={intl.messages.DEFAULT_PAGE}
            value={value}
            onChange={handleChange}
          >
            {routesOptions.map((routeName) => {
              return (
                <MenuItem key={routeName} value={routeName}>
                  {intl.messages[routeName] || routeName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </FullSizeCenteredColumn>
    </Dialog>
  );
};

export default DefaultPageDialog;
